import { render } from "./FreeAddOnDialog.vue?vue&type=template&id=2812e371&scoped=true"
import script from "./FreeAddOnDialog.vue?vue&type=script&lang=js"
export * from "./FreeAddOnDialog.vue?vue&type=script&lang=js"

import "./FreeAddOnDialog.vue?vue&type=style&index=0&id=2812e371&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2812e371"]])

export default __exports__